module.exports = __webpack_public_path__ + "play.a4e1316e.png";